import script from "./TodayFromMystics.vue?vue&type=script&setup=true&lang=js"
export * from "./TodayFromMystics.vue?vue&type=script&setup=true&lang=js"

import "./TodayFromMystics.vue?vue&type=style&index=0&id=3ae26da4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ae26da4"]])

export default __exports__